/* eslint-disable import/prefer-default-export */
import { styled } from '@mui/material';
import Box from '@mui/material/Box';

export const StyledBox = styled(Box)(({ theme }) => ({
  paddingInline: theme.spacing(5),
  paddingBlockEnd: theme.spacing(5),
}));
